export default "__VITE_ASSET__CRY9yYqX__"